import { render, staticRenderFns } from "./point.vue?vue&type=template&id=39a76510&"
import script from "./point.vue?vue&type=script&lang=js&"
export * from "./point.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/node/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39a76510')) {
      api.createRecord('39a76510', component.options)
    } else {
      api.reload('39a76510', component.options)
    }
    module.hot.accept("./point.vue?vue&type=template&id=39a76510&", function () {
      api.rerender('39a76510', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/moomoomembers/point.vue"
export default component.exports